import { useEffect, useState } from 'react';
const portraits = new Map();
export async function preloadPortraits(elements) {
  const photos = [...new Set((elements || []).map(el => el.shape === 'board_image' ? el.image : el.photo).filter(photo => /^data:image\/(jpeg|png|webp);base64,/.test(photo || '')))];
  const required = new Set((elements || []).filter(el => el.shape === 'board_image').map(el => el.image));
  await Promise.all(photos.map(photo => new Promise((resolve, reject) => {
    if (portraits.get(photo)?.complete && portraits.get(photo)?.naturalWidth) { resolve(); return; }
    const img = new Image();
    portraits.set(photo, img);
    const failed = () => required.has(photo)
      ? reject(new Error('No se pudo cargar una imagen de la pizarra. Vuelve a subirla antes de exportar.'))
      : resolve();
    const timer = setTimeout(failed, 5000);
    img.onload = () => { clearTimeout(timer); resolve(); window.dispatchEvent(new Event('micoach:portrait-ready')); };
    img.onerror = () => { clearTimeout(timer); failed(); };
    img.src = photo;
  })));
}
export function drawBoardPicture(ctx, element) {
  const photo = element.image;
  if (!/^data:image\/(jpeg|png|webp);base64,/.test(photo || '')) return;
  let img = portraits.get(photo);
  if (!img) {
    img = new Image(); portraits.set(photo, img);
    img.onload = () => window.dispatchEvent(new Event('micoach:portrait-ready'));
    img.src = photo;
  }
  const width = element.width || 820, height = element.height || 544;
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, width, height);
  if (!img.complete || !img.naturalWidth) return;
  const scale = Math.min(width / img.naturalWidth, height / img.naturalHeight);
  const w = img.naturalWidth * scale, h = img.naturalHeight * scale;
  ctx.drawImage(img, (width - w) / 2, (height - h) / 2, w, h);
}
export function usePortraitRevision() {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const refresh = () => setVersion(v => v + 1);
    window.addEventListener('micoach:portrait-ready', refresh);
    return () => window.removeEventListener('micoach:portrait-ready', refresh);
  }, []);
  return version;
}
export function drawPortrait(ctx, photo, x, y, radius = 13) {
  if (!/^data:image\/(jpeg|png|webp);base64,/.test(photo || '')) return false;
  let img = portraits.get(photo);
  if (!img) {
    img = new Image();
    if (portraits.size > 100) portraits.delete(portraits.keys().next().value);
    portraits.set(photo, img);
    img.onload = () => window.dispatchEvent(new Event('micoach:portrait-ready'));
    img.src = photo;
  }
  if (!img.complete || !img.naturalWidth) return false;
  ctx.save();
  ctx.beginPath(); ctx.arc(x, y, radius, 0, Math.PI * 2); ctx.clip();
  ctx.drawImage(img, x - radius, y - radius, radius * 2, radius * 2);
  ctx.restore();
  return true;
}
